<div class="w-full h-full flex flex-col gap-4 p-4 md:p-6 max-h-[90vh] overflow-hidden">
	<div class="flex flex-row justify-between items-start gap-4 flex-shrink-0">
		<div class="flex flex-col gap-1">
			<span class="text-xl font-semibold">Detalle del pedido</span>
			<span class="text-sm text-secondary-300">Pedido {{ data.orderNumber || '-' }} · {{ data.date ? (data.date |
				date:'dd/MM/yyyy') : '-' }}</span>
			@if (activeWarehouse()) {
				<span class="text-sm text-secondary-300">
					Bodega: {{ activeWarehouse()?.code }} - {{ activeWarehouse()?.name }}
				</span>
			}
		</div>
		<button class="rounded-3xl flex items-center gap-3 bg-orange-500 text-white py-4 px-8 cursor-pointer"
			(click)="close()">
			<span class="text-base">Cerrar</span>
			<i class="fi-rr-cross-small text-2xl flex"></i>
		</button>
	</div>
	<div class="flex-1 overflow-auto min-h-0">
		<p-table *ngIf="items && items.length; else emptyItems" [value]="items" [paginator]="false" styleClass="w-full"
			[tableStyle]="{ 'table-layout': 'fixed', 'width': '97%' }"
			currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} productos">
			<ng-template pTemplate="header">
				<tr>
					<th style="width: 45%;" class="px-4 py-2 text-left font-semibold text-base">Producto</th>
					<th style="width: 19%;" class="px-4 py-2 text-left font-semibold text-base">Plataformas</th>
					<th style="width: 9%;" class="px-4 py-2 text-left font-semibold text-base">Cantidad</th>
					<th style="width: 10%;" class="px-4 py-2 text-left font-semibold text-base">Fecha Promesa</th>
					<th style="width: 9%;" class="px-4 py-2 text-left font-semibold text-base">Valor unitario</th>
					<th style="width: 8%;" class="px-4 py-2 text-left font-semibold text-base">Valor Total</th>
					<th style="width: 10%;" class="px-4 py-2 text-left font-semibold text-base">Estado de Línea</th>
				</tr>
			</ng-template>

			<ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
				<tr class="hover:bg-orange-50">
					<td class="px-4 py-2 gap-8">
						<div class="flex items-start gap-3">
							<img role="presentation" class="rounded-lg flex-shrink-0 object-cover" [alt]="item.name"
								[src]="item.productImage || '/asset/imagen-no-disponible-1.jpg'" width="80" height="80" />
							<div class="flex flex-col min-w-0 flex-1">
								<div class="font-semibold text-sm leading-tight break-words">{{ item.name }}</div>
								<div class="text-[11px] text-gray-500 mt-0.5">
									ID: {{ item.id }}
								</div>
								<div *ngIf="item.description" class="text-[11px] text-gray-500 mt-0.5 break-words whitespace-normal">
									{{ item.description }}
								</div>
								<div class="text-xs text-text-secondary mt-0.5 break-words whitespace-normal">
									{{ getItemSize(item) }}
								</div>
								<div class="text-xs text-text-secondary mt-0.5 break-words whitespace-normal">
									{{ getItemFeatures(item) }}
								</div>
								<div *ngIf="item.faceOne || item.faceTwo" class="text-[11px] text-text-secondary mt-0.5 break-words">
									Caras: {{ getItemCoating(item) }}
								</div>
								<div *ngIf="item.sku" class="text-[11px] text-text-secondary mt-0.5 break-words">
									{{ item.sku }}
								</div>
							</div>
						</div>
					</td>
					<td class="text-[11px] text-black-500 mt-0.5">
						<div *ngIf="getPlatformBreakdown(item)?.length; else noPlatforms" class="flex flex-col gap-1">
							<div *ngFor="let p of getPlatformBreakdown(item)" class="text-[12px] text-secondary-700">
								{{ p.count }} × {{ p.label }}
								<ng-container *ngIf="p.unitSize != null"> ({{ p.unitSize }} c/u)</ng-container>
							</div>
						</div>
						<ng-template #noPlatforms>
							<span class="text-secondary-400 text-[12px]">—</span>
						</ng-template>
					</td>
					<td class="text-sm px-4 py-2">{{ item.quantity }}</td>
					<td class="text-sm px-4 py-2">
						<span *ngIf="item.deliveryDate; else noDate">{{ item.deliveryDate | date:'dd/MM/yyyy' }}</span>
						<ng-template #noDate><span class="text-secondary-400 text-xs">—</span></ng-template>
					</td>
					<td class="text-sm px-4 py-2">${{ item.price | number:'1.2-2' }}</td>
					<td class="text-sm px-4 py-2">${{ (item.price * item.quantity) | number:'1.2-2'
						}}</td>
					<td class="text-sm px-4 py-2">
						<div *ngIf="item.lineStatus; else noStatus" class="flex flex-col gap-1">
							<span class="text-[11px] text-black-500 mt-0.5">{{ item.lineStatus }}</span>
						</div>
						<ng-template #noStatus>
							<span class="text-secondary-400 text-xs">—</span>
						</ng-template>
					</td>
				</tr>
			</ng-template>
		</p-table>

		<ng-template #emptyItems>
			<div class="h-full flex items-center justify-center bg-yellow-100 p-8 rounded-2xl text-center">No se
				encontraron productos para este pedido.</div>
		</ng-template>
	</div>

	<div class="flex justify-between items-center flex-shrink-0">
		<a class="rounded-3xl flex items-center gap-3 border-2 px-4 py-3 bg-white hover:bg-gray-100 text-primary-300 font-semibold cursor-pointer"
			(click)="openSupport()" title="Contactar soporte">
			<span class="text-base">Contactar soporte</span>
			<i class="fi-rr-headset text-2xl flex"></i>
		</a>

		<div class="flex flex-col text-right">
			<span class="text-sm text-secondary-500">Total del pedido</span>
			<span class="text-2xl font-semibold text-primary-300">${{ total | number:'1.2-2' }}</span>
		</div>
	</div>

	<div class="support-modal" *ngIf="showSupportOptions && data">
		<div class="support-header flex flex-row justify-between items-start gap-4">
			<h1 class="font-semibold text-2xl pb-3">
				Contactar soporte
			</h1>
			<button class="flex items-center justify-center text-black-400 hover:text-black-600 cursor-pointer pt-1"
				(click)="showSupportOptions = false">
				<i class="fi-rr-cross-small text-3xl flex"></i>
			</button>
		</div>

		<div class="px-6 py-2 w-full box-border flex flex-col gap-4">
			<div class="flex flex-col gap-4 w-full">
				<div class="flex flex-col md:flex-row gap-4 w-full">
					<div class="flex-1">
						<label class="text-gray-500 block mb-1 text-sm">Pedido</label>
						<input [disabled]="true" type="text" [value]="data.orderNumber || '-'"
							class="w-full py-3 px-3 border border-gray-400 rounded-2xl focus:outline-none placeholder-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed text-sm" />
					</div>
					<div class="flex-1">
						<label class="text-gray-500 block mb-1 text-sm">Usuario</label>
						<input [disabled]="true" type="text" [value]="userName || '-'"
							class="w-full py-3 px-3 border border-gray-400 rounded-2xl focus:outline-none placeholder-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed text-sm" />
					</div>
				</div>

				<div class="flex-1">
					<label class="text-gray-500 block mb-1 text-sm">Cliente</label>
					<input [disabled]="true" type="text" [value]="customerName || '-'"
						class="w-full py-3 px-3 border border-gray-400 rounded-2xl focus:outline-none placeholder-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed text-sm" />
				</div>

				<div class="flex-col w-full">
					<label class="text-gray-500 block mb-1 text-sm">Describe tu consulta o problema</label>
					<textarea #supportTextarea
						class="w-full h-40 p-3 border border-gray-400 rounded-2xl resize-none focus:outline-none focus:ring-2 focus:ring-orange-400 text-sm placeholder-gray-400"
						placeholder="Escribe aquí los detalles de tu consulta o problema..."
						[(ngModel)]="supportMessage"></textarea>
				</div>

				<div class="support-cards w-full box-border flex flex-col sm:flex-row gap-4 mb-2">
					<div class="support-card whatsapp flex-1" (click)="contactWhatsApp()">
						<i class="fi-brands-whatsapp text-3xl whatsapp-icon"></i>
						<div class="card-text">
							<h4>WhatsApp</h4>
							<p>Se abrirá un chat con tu asesor</p>
						</div>
					</div>

					<div class="support-card email flex-1" (click)="contactEmail()">
						<i class="fi-rr-envelope text-3xl"></i>
						<div class="card-text">
							<h4>Correo electrónico</h4>
							<p>Tu solicitud será enviada por correo</p>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>